import { useParams, useNavigate } from "react-router-dom";
import { movies } from "../data/appData";

export default function Movies() {
  const { id } = useParams();   // aha, netflix etc
  const nav = useNavigate();

  const list = movies[id] || [];

  return (
    <div className="moviesPage">

      <h2 className="pageTitle">
        {id.toUpperCase()} Movies
      </h2>

      <div className="movieGrid">
        {list.map((m) => (
          <div
            key={m.id}
            className="movieCard"
            onClick={() =>
              nav(`/play/${id}/${m.id}`)
            }
          >
            <img src={m.poster} alt={m.title} />

            {/* PLAY ICON */}
            <div className="playBtn">▶</div>

            <p>{m.title}</p>
          </div>
        ))}
      </div>

      {/* STYLE */}
      <style>{`
        .moviesPage {
          padding: 30px 40px;
        }

        .pageTitle {
          margin-bottom: 22px;
        }

        .movieGrid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 30px;   /* GAP FIX */
        }

        .movieCard {
          position: relative;
          cursor: pointer;
          transition: 0.3s;
        }

        .movieCard img {
          width: 100%;
          border-radius: 12px;
        }

        .movieCard p {
          margin-top: 8px;
          font-size: 14px;
        }

        /* PLAY BTN */
        .playBtn {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 44px;
          background: rgba(0,0,0,0.55);
          border-radius: 12px;
          opacity: 0;
          transition: 0.3s;
        }

        .movieCard:hover .playBtn {
          opacity: 1;
        }

        .movieCard:hover {
          transform: scale(1.08);
        }
      `}</style>
    </div>
  );
}
